import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CidaasService } from 'src/app/service/cidaas.service';
import { CommonFunctionsService } from 'src/app/service/common-functions.service';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ILocation, LocationHelper } from '../../../helpers/location.helper';
import { KEY_DEFAULT_ERROR } from '../../../model/error.model';
import { K } from "@angular/cdk/keycodes";

@Component({
  selector: 'app-verification-complete',
  templateUrl: './verification-complete.component.html',
  styleUrls: ['./verification-complete.component.scss'],
})
export class VerificationCompleteComponent implements OnInit {
  inputGroupOption = {
    input: {
      label: 'VERIFICATION_COMPLETE.PLACEHOLDER',
      placeholder: '',
      hint: '',
      value: '',
      type: 'input',
    },
    button: {
      text: 'NEXT',
      color: 'accent',
      showImg: false
    },
  };
  buttonOptions: any = {
    backToLogin: {
      color: 'accent',
      text: 'BACK_TO_LOGIN',
      alignment: 'right',
      type: 'proceed',
      underline: 'none'
    }
  }
  verificationCode!: string;
  // isVerificationSuccessful: boolean;
  requestId!: string;
  accvid: any;
  errorMessage: string = '';
  type: string = 'email';
  rememberMe: boolean = false;
  email_verified: any;
  processingType: any;
  usage_type: any;
  sub: any;
  isVerificationSuccessful: boolean = false;
  goBack_url: any;
  suggested_action: any;
  trackId: any;
  client_display_name: any;
  location: ILocation = {
    lat: '',
    lon: ''
  };
  verificationType: any;
  status_id: any;
  pageLoading: boolean = false;
  updateInProgress = false;
  constructor(private cidaas: CidaasService, private route: ActivatedRoute, public commonFunc: CommonFunctionsService, private dataShareSrv: SharedDataService) {
    // this.isVerificationSuccessful = false;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.requestId = params.requestId || null;
      this.accvid = params.accvid || null;
      this.type = params.type || null;
      this.processingType = params.processingType || 'CODE';
      this.usage_type = params.usage_type;
      this.sub = params.sub;
      this.status_id = params.status_id;
      this.verificationType = params.verificationType;
      this.email_verified = params.email_verified || false;
      this.suggested_action = params.suggested_action || null;
      this.trackId = params.trackId || null;
      this.loginAfterRegister(params);
    });
    this.getLatLon();
    this.dataShareSrv._getClientInfo().subscribe((data) => {
      if (data && data.is_remember_me_selected) {
        this.rememberMe = true;
      }
      if (data && data.client_display_name) {
        this.client_display_name = data.client_display_name;
      }
    });
  }

  loginAfterRegister(params: Params): void {
    if (this.suggested_action == 'LOGIN' && this.trackId && !this.usage_type) {
      this.type = params.verificationMedium || null;
      this.isVerificationSuccessful = true;
      const location = LocationHelper.getLocationInfo();
      let data: any = {};
      data.trackId = this.trackId;
      data.lat = this.location.lat;
      data.lon = this.location.lon;
      setTimeout(() => {
        this.cidaas._loginAfterRegister(data)
          .catch(() => this.errorMessage = KEY_DEFAULT_ERROR);
      }, 1000);
    } else {
      if (this.processingType === 'CODE') {
        this.isVerificationSuccessful = false;
      }
      if (this.processingType === 'LINK') {
        if (this.email_verified === 'true') {
          this.type = params.verificationMedium || null;
          this.isVerificationSuccessful = true;
        } else {
          this.isVerificationSuccessful = false;
        }

        // mfa or passwordless
        var data: any = {
          sub: this.sub,
          status_id: this.status_id,
          requestId: this.requestId,
          verificationType: this.verificationType,
          lat: this.location.lat,
          lon: this.location.lon
        }
        if (this.usage_type == 'PASSWORDLESS_AUTHENTICATION') {
          setTimeout(() => {
            this.cidaas._passwordlessLogin(data);
          }, 1000);
        }
        if (this.usage_type == 'MULTIFACTOR_AUTHENTICATION' && this.trackId) {
          data["track_id"] = this.trackId;
          data['lat'] = this.location.lat;
          data['lon'] = this.location.lon;
          setTimeout(() => {
            this.cidaas.mfaContinue(data);
          }, 1000);
        }
      }
    }
  }

  getLatLon(): void {
    const lat = localStorage.getItem('lat');
    const lon = localStorage.getItem('lon');
    if (lat && lon) {
      this.location.lat = lat;
      this.location.lon = lon;
    } else {
      LocationHelper.getLocationInfo().then((info: ILocation) => {
        this.location = info;
      }).catch((error) => {
        this.location.lat = '';
        this.location.lon = '';
      });
    }
  }

  async submit(): Promise<void> {
    if (!this.verificationCode || this.verificationCode.length === 0) {
      this.errorMessage = 'INVALID_CODE';
      return;
    }
    this.updateInProgress = true;
    const response = await this.cidaas._get().verifyAccount({
      accvid: this.accvid,
      code: this.verificationCode,
    });
    this.updateInProgress = false;
    if (response && response.data && response.data.suggested_action == 'LOGIN' && response.data.trackId) {
      try {
        await this.loginAFterVerification(response.data);
      } catch (e) {
        this.errorMessage = KEY_DEFAULT_ERROR;
      }
    } else {
      this.isVerificationSuccessful = !!response && response.success;
    }
    if (response && response.error) {
      if (response.error.error === ('Invalid code')) {
        this.errorMessage = 'INVALID_CODE';
      } else if (response.error.error === ('Given request id is already used')) {
        this.errorMessage = 'VERIFICATION_COMPLETE.ACCOUNT_ALREADY_VERIFIED';
      } else if (response.error.error === ('Code Request expired')) {
        this.errorMessage = 'VERIFICATION_COMPLETE.CODE_EXPIRED';
      } else {
        this.errorMessage = KEY_DEFAULT_ERROR;
      }
    }
  }

  async loginAFterVerification(data): Promise<void> {
    data.rememberMe = this.rememberMe;
    data.lat = this.location.lat;
    data.lon = this.location.lon;
    this.pageLoading = true;
    await this.cidaas._loginAfterRegister(data);
  }

  updateVerificationCode(code: string): void {
    this.verificationCode = code;
  }

  async goToRedirect(): Promise<void> {
    location.href = environment.base_url + 'authz-srv/authz/resolve_redirect/' + this.requestId;
  }
}
